import React from 'react';
import { ErrorPage } from '../../components/common/page/ErrorPage';
import { useDocumentTitle } from '../../hooks/useDocumentTitle';

export const TooManyRequestsPage = () => {
    useDocumentTitle('Too Many Requests');
    return (
        <ErrorPage
            code="429"
            title="Too Many Requests"
            description="Sorry! Rate limit exceeded.<br/> Try again later">
            <div className="too-many-requests-icon text-center">
                <span className="fa-stack fa-5x mt-5 mb-3">
                    <i
                        className="fas fa-whale fa-stack-2x text-muted"
                        data-fa-transform="rotate-45 left-2 up-4"></i>
                    <i
                        className="fas fa-filter fa-stack-1x text-primary"
                        data-fa-transform="shrink-5 right-2 down-16"></i>
                </span>
            </div>
        </ErrorPage>
    );
};
